document.addEventListener('DOMContentLoaded', function () {
  const firstNameInput = document.querySelector('#ContactFooter .newsletter-name__input');
  const emailInput = document.querySelector('#ContactFooter .newsletter-email__input');
  const nameErrorElement = document.querySelector('.error');
  const emailErrorElement = document.querySelector('.email-error');
  const submitButton = document.getElementById('Subscribe');

  // Validate the first name input
  function validateFirstName() {
    const nameRegex = /^[A-Za-z\s]+$/;
    if (firstNameInput.value.trim() === '') {
      nameErrorElement.textContent = "Inserisca il suo Nome.";
      nameErrorElement.classList.remove('hidden');
      return false;
    } else if (!nameRegex.test(firstNameInput.value.trim())) {
      nameErrorElement.textContent = 'Sono consentite solo lettere e spazi.';
      nameErrorElement.classList.remove('hidden');
      return false;
    } else {
      nameErrorElement.classList.add('hidden');
      return true;
    }
  }

  // Validate the email input
  function validateEmail() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    if (emailInput.value.trim() === '') {
      emailErrorElement.textContent = "Per favore inserisci lindirizzo e-mail.";
      emailErrorElement.classList.remove('hidden');
      return false;
    } else if (!emailRegex.test(emailInput.value.trim())) {
      emailErrorElement.textContent = 'Si prega di inserire un indirizzo email valido.';
      emailErrorElement.classList.remove('hidden');
      return false;
    } else {
      emailErrorElement.classList.add('hidden');
      return true;
    }
  }

  // Check overall form validity and enable/disable submit button
  function updateButtonState() {
    const isFormValid = validateFirstName() && validateEmail();
    if (isFormValid) {
      submitButton.disabled = false;
      submitButton.classList.remove('disabled');
    } else {
      submitButton.disabled = true;
      submitButton.classList.add('disabled');
    }
  }

  // Input event listeners for immediate validation
  firstNameInput?.addEventListener('input', function () {
    document.querySelector('.newsletter-success__text')?.classList.add('hidden');
    validateFirstName(); // Validate first name field
    updateButtonState(); // Update button state based on overall validity
  });

  emailInput?.addEventListener('input', function () {
    document.querySelector('.newsletter-success__text')?.classList.add('hidden');
    validateEmail(); // Validate email field
    updateButtonState(); // Update button state based on overall validity
  });

  submitButton?.addEventListener('click', (event) => {
    const firstName = validateFirstName();
    if (firstName == true) {
      validateEmail(); 
    } else {
      event.preventDefault();
    }
  })

});